import { useState } from 'react';
import { Box, Divider, Paper } from '@mui/material';
import { useStyles } from './styles/OrgNav.styles';
import { Panel } from './Panel';
import { Tree, useTreeState } from './Tree';
// import { ActionButtons } from './ActionButtons';
import { ActionBar } from './ActionBar';
import { Operation } from '@/types/general';
import { Selection } from './Tree/types';

export const OrgNav = () => {
    const classes = useStyles();

    // Necessary for virtualization of the tree
    const [root, setRoot] = useState<HTMLDivElement | null>(null);

    const [selection, setSelection] = useTreeState();

    const [operation, setOperation] = useState(Operation.Edit);
    const resetMode = () => setOperation(Operation.Edit);

    return (
        <>
            <Paper elevation={4} className={classes.container}>
                <Box ref={setRoot} className={`${classes.content} ${classes.leftContent}`}>
                    <Tree selection={selection} setSelection={setSelection} root={root} onSelect={resetMode} />
                </Box>

                <Divider orientation='vertical' />

                <Box sx={{ display: 'flex', flexDirection: 'column', boxSizing: 'border-box', flex: 1 }}>
                    <ActionBar
                        onCreate={(type) => {
                            setSelection({
                                [Selection.Company]: null,
                                [Selection.Reseller]: null,
                                [Selection.Location]: null,
                                type,
                                groups: [],
                            });
                            setOperation(Operation.Create);
                        }}
                    />

                    <Divider />

                    <Box className={`${classes.content} ${classes.rightContent}`}>
                        {/* todo: onSuccess, take the user to the new entity they created? */}
                        <Panel selection={selection} operation={operation} onSuccess={resetMode} />
                    </Box>
                </Box>
            </Paper>
        </>
    );
};
